import React, { createContext, useState, useContext } from 'react'

const AdminContext = createContext()

export function AdminProvider({children}) {

    const [consultoras, setConsultoras] = useState([])
    const [loadingConsultoras, setLoadingConsultoras] = useState(true)
    const [errorConsultora, setErrorConsultora] = useState(null)

    const [errorArea, setErrorArea] = useState(null) 

    const [empresas, setEmpresas] = useState([])
    const [loadingEmpresas, setLoadingEmpresas] = useState(false)
    const [errorEmpresa, setErrorEmpresa] = useState(null)

    const [empleados, setEmpleados] = useState([])
    const [loadingEmpleado, setLoadingEmpleado] = useState(false)
    const [errorEmpleado, setErrorEmpleado] = useState(null)

    const [empConsul, setEmpConsul] = useState([])
    const [loadingEmpConsul, setLoadingEmpConsul] = useState(true)
    const [errorEmpConsul, setErrorEmpConsul] = useState(null)

    const fetchConsultoras = async (user) => {
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/index/consultorasView`,{
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    user,
                })
            })
            const data = await res.json()
            if(data.status !== 0){
                setErrorConsultora(data.codeError)
                setLoadingConsultoras(false)
            } else {
                setConsultoras(data.objeto)
                setLoadingConsultoras(false)  
            }
        } catch (error) {
            setErrorConsultora("Error: Conexión con backend.")
        }
    }

    const fetchEmpresasSinConsultora = async (user) => {
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/index/sinEmpresasView`,{
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    user,
                })
            })
            const data = await res.json()
            if(data.status !== 0){
                setErrorEmpresa(data.errorDetalle)
                setLoadingEmpresas(false)
            } else {
                setEmpresas(data.objeto)
                setLoadingEmpresas(false)  
            }
        } catch (error) {
            setErrorEmpresa("Error: Conexión con backend.")
        }
    }

    const fetchEmpresasById = async (user, id) => {
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/index/empresasView`,{
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    user,
                    idConsultora: parseInt(id)
                })
            })
            const data = await res.json()
            if(data.status !== 0){
                setErrorEmpresa(data.errorDetalle)
                setLoadingEmpresas(false)
            } else {
                setEmpresas(data.objeto)
                setLoadingEmpresas(false)  
            }
        } catch (error) {
            setErrorEmpresa("Error: Conexión con backend.")
        }
    }

    const fetchEmpleadosById = async (user, id) => {
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/user/viewUserCompany`,{
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    user: user,
                    idEmpresa: parseInt(id)
                })
            })
            const data = await res.json()
            if(data.status !== 0){
                setErrorEmpleado(data.codeError)
                setLoadingEmpleado(false)
            } else {
                setEmpleados(data.objeto)
                setLoadingEmpleado(false)  
            }
        } catch (error) {
            setErrorEmpleado("Error: Conexión con backend.")
        }
    }

    const fetchEmpleadoConsultoraById = async (user, id) => {
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/user/viewUserConsultora`,{
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    user: user,
                    idConsultora: parseInt(id)
                })
            })
            const data = await res.json()
            const errorCode = data.status ?? data.error
            if(errorCode !== 0){
                setErrorEmpConsul(errorCode.errorDetalle)
                setLoadingEmpConsul(false)
            } else {
                setEmpConsul(data.objeto)
                setLoadingEmpConsul(false)  
            }
        } catch (error) {
            setErrorEmpConsul("Error: Conexión con backend.")
        }
    }

    const fetchArea = async (user, idEmpresa) => {
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/index/areasView`,{
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    user: user,
                    idEmpresa: idEmpresa
                })
            })
            const data = await res.json()
            return data
        } catch (error) {
            setErrorArea("Error: Conexión con backend.")
        }
    }

    return (
        <AdminContext.Provider value={{ 
            consultoras, 
            loadingConsultoras, 
            setLoadingConsultoras, 
            errorConsultora, 
            setErrorConsultora, 
            fetchConsultoras, 
            empresas, 
            loadingEmpresas, 
            errorEmpresa, 
            setErrorEmpresa, 
            fetchEmpresasSinConsultora, 
            fetchEmpresasById, 
            errorEmpleado, 
            setErrorEmpleado, 
            empleados, 
            setEmpleados, 
            loadingEmpleado, 
            setLoadingEmpleado, 
            fetchEmpleadosById, 
            errorArea, 
            setErrorArea, 
            fetchArea, 
            fetchEmpleadoConsultoraById,
            empConsul,
            setEmpConsul,
            errorEmpConsul,
            setErrorEmpConsul,
            loadingEmpConsul,
            setLoadingEmpConsul
        }}>
            {children}
        </AdminContext.Provider>
    )
}

export function useAdmin () {
    return useContext(AdminContext)
}